import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo, Button } from "@/lib/ui";

export default function Welcome() {
  const nav = useNavigate();
  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-white">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/10261153/pexels-photo-10261153.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/90 to-slate-900/70" />

      <div className="relative z-10 flex min-h-screen flex-col">
        <header className="flex items-center justify-between px-6 py-5 sm:px-10">
          <Logo dark />
          <button
            data-testid="admin-entry-link"
            onClick={() => nav("/admin/login")}
            className="text-xs font-semibold uppercase tracking-wider text-slate-400 hover:text-orange-400"
          >
            Admin
          </button>
        </header>

        <main className="flex flex-1 flex-col items-start justify-center px-6 sm:px-10 lg:px-20">
          <div className="max-w-3xl fade-up">
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-orange-500">
              India's Dead-Stock Marketplace
            </p>
            <h1 className="font-head text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              DEAD TO <span className="text-orange-500">LIVE.</span>
            </h1>
            <p className="mt-3 font-head text-lg font-semibold uppercase tracking-wide text-slate-400 sm:text-xl">
              Where dead stock finds its buyer.
            </p>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-300">
              Discover surplus, clearance and slow-moving stock from retailers and wholesalers across India.
              See the actual stock. Connect directly on WhatsApp. Get a great deal.
            </p>

            <div className="mt-8 flex flex-wrap gap-4 text-xs font-semibold uppercase tracking-wider text-slate-400">
              <span><i className="fa-solid fa-magnifying-glass mr-2 text-orange-500" />Discover</span>
              <span><i className="fa-solid fa-images mr-2 text-orange-500" />See Actual Stock</span>
              <span><i className="fa-brands fa-whatsapp mr-2 text-emerald-500" />Connect</span>
              <span><i className="fa-solid fa-boxes-packing mr-2 text-orange-500" />Get A Great Deal</span>
            </div>

            <div className="mt-10 grid w-full max-w-2xl gap-4 sm:grid-cols-2">
              <button
                data-testid="role-select-buyer-btn"
                onClick={() => nav("/buyer")}
                className="group rounded-2xl border border-white/10 bg-white/5 p-6 text-left backdrop-blur transition hover:-translate-y-0.5 hover:border-orange-500 hover:bg-white/10"
              >
                <i className="fa-solid fa-cart-shopping mb-3 text-2xl text-orange-500" />
                <p className="font-head text-xl font-bold">I AM A BUYER</p>
                <p className="mt-1 text-sm text-slate-400">Browse & discover live dead stock near you or pan-India.</p>
                <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-orange-400">
                  Enter marketplace <i className="fa-solid fa-arrow-right transition group-hover:translate-x-1" />
                </span>
              </button>

              <button
                data-testid="role-select-seller-btn"
                onClick={() => nav("/seller")}
                className="group rounded-2xl border border-white/10 bg-white/5 p-6 text-left backdrop-blur transition hover:-translate-y-0.5 hover:border-emerald-500 hover:bg-white/10"
              >
                <i className="fa-solid fa-store mb-3 text-2xl text-emerald-500" />
                <p className="font-head text-xl font-bold">I AM A SELLER</p>
                <p className="mt-1 text-sm text-slate-400">List your existing stock and reach the right buyers.</p>
                <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-emerald-400">
                  List your stock <i className="fa-solid fa-arrow-right transition group-hover:translate-x-1" />
                </span>
              </button>
            </div>
          </div>
        </main>

        <footer className="px-6 py-5 text-xs text-slate-500 sm:px-10">
          Deadstock.live — the product is the stock, the marketplace is the discovery, WhatsApp is the connection.
        </footer>
      </div>
    </div>
  );
}
